// src/schedule/StaffMenu.js
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';

const StaffMenu = ({ onRemove, onToggleTentative }) => {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [menuStyle, setMenuStyle] = useState({});

    // Pozycjonowanie menu w portalu
    useLayoutEffect(() => {
        if (!open || !buttonRef.current || !menuRef.current) {
            setMenuStyle({});
            return;
        }

        const updatePosition = () => {
            const buttonRect = buttonRef.current.getBoundingClientRect();
            const menuRect = menuRef.current.getBoundingClientRect();
            
            // Pozycjonuj menu po prawej stronie przycisku
            setMenuStyle({
                position: 'fixed',
                top: `${buttonRect.bottom + 4}px`,
                right: `${window.innerWidth - buttonRect.right}px`,
                zIndex: 2147483648, // Wyższy niż powiększona karta
            });
        };

        updatePosition();
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);

        return () => {
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
        };
    }, [open]);

    // Zamknięcie menu po kliknięciu poza nim
    useEffect(() => {
        if (!open) return;
        
        const handleClickOutside = (e) => {
            if (buttonRef.current && !buttonRef.current.contains(e.target) &&
                menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    return (
        <>
            <div className="relative" ref={buttonRef} onClick={(e) => e.stopPropagation()}>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen(prev => !prev);
                    }}
                    className="text-gray-400 hover:text-white px-1"
                    title="Opcje"
                >
                    ⋮
                </button>
            </div>
            {open && typeof document !== 'undefined' && createPortal(
                <div 
                    ref={menuRef}
                    className="w-32 bg-gray-800 border border-gray-600 rounded shadow-lg"
                    style={menuStyle}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggleTentative();
                            setOpen(false);
                        }}
                        className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-600 flex items-center gap-2"
                    >
                        ❓ <span>Niepewny</span>
                    </div>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove();
                            setOpen(false);
                        }}
                        className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-600 flex items-center gap-2 text-red-400"
                    >
                        ❌ <span>Usuń</span>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default StaffMenu;
